/**
 * dir-w | backOffice
 * Under construction page content
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { Component } from '@angular/core';
import { Configuration } from '../../config/configuration';

@Component({
    selector: 'app-page-under-construction',
    templateUrl: './page-under-construction.component.html',
    styleUrl: './page-under-construction.component.css',
    standalone: false
})
export class PageUnderConstructionComponent {
  protected profilePath: string = `/assets/profile/${Configuration.Profile}/images/background.png`;
  protected underConstructionPath: string = `/assets/profile/${Configuration.Profile}/images/under-constructions.png`;
}
